import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import * as Icon from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
//api
import { getDataUser, saveUserName } from './ProfileSlice';

const InformationAccount = () => {
  const { t } = useTranslation();
  const dataUser = useSelector((state) => state.profile.profile);
  const token = localStorage.getItem('token');
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getDataUser(token));
  }, [token, dispatch]);

  // edit
  const typeAcc = useSelector((state) => state.profile.profile.authority);

  const [isEdit, setIsEdit] = useState(false);
  const [userName, setUserName] = useState();
  const [curUserName, setCurUserName] = useState();
  useEffect(() => {
    if (typeAcc === 'CUSTOMER_USER') {
      setUserName(dataUser.firstName);
      setCurUserName(dataUser.firstName);
    } else {
      setUserName(dataUser.name);
    }
  }, [typeAcc]);

  const toggleEdit = () => {
    setIsEdit(true);
    document.getElementById('customerName').focus();
  };

  const handleCancel = () => {
    document.getElementById('customerName').value = curUserName;
    setIsEdit(false);
  };

  const handleSubmitCustomer = () => {
    const user = {
      customerId: {
        entityType: 'CUSTOMER',
        id: dataUser.customerId.id,
      },
      tenantId: {
        entityType: 'TENANT',
        id: dataUser.tenantId.id,
      },
      id: {
        entityType: 'USER',
        id: dataUser.id.id,
      },
      authority: 'CUSTOMER_USER',
      firstName: userName,
      email: dataUser.email,
    };
    dispatch(saveUserName({ token, user }));
    dispatch(getDataUser(token));
    setIsEdit(false);
    setCurUserName(userName);
  };
  return (
    <Col md={6}>
      <Card>
        <Card.Header sm={12}>
          <h5>{t('account-information')}</h5>
          {typeAcc === 'CUSTOMER_USER' ? (
            <div className="profile-customer__edit" onClick={toggleEdit}>
              <Icon.Edit3 />
            </div>
          ) : (
            ''
          )}
        </Card.Header>
        <Card.Body>
          <Row>
            {/* <Col sm={4}>
              <Form.Group>
                <div className="text-center">
                  <img src={avatar} id="avatar" alt="avatar" />
                  <p> {t('avatar')} </p>
                </div>
              </Form.Group>
            </Col> */}

            <Col>
              <div className="input-group mb-3">
                <div className="input-group-prepend text-profile">
                  <span className="input-group-text" id="basic-addon1">
                    {t('role')}
                  </span>
                </div>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={dataUser.authority}
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  disabled
                />
              </div>

              <div className="input-group mb-3">
                <div className="input-group-prepend text-profile">
                  <span className="input-group-text" id="basic-addon1">
                    {t('email')}
                  </span>
                </div>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={dataUser.email}
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  disabled
                />
              </div>

              <div className="input-group mb-3">
                <div className="input-group-prepend text-profile">
                  <span className="input-group-text">{t('name')}</span>
                </div>
                <input
                  type="text"
                  id="customerName"
                  className="form-control"
                  defaultValue={userName}
                  readOnly={!isEdit}
                  onChange={(e) => setUserName(e.target.value)}
                />
              </div>
              <div
                className={
                  isEdit ? 'submit__customer show' : 'submit__customer'
                }
              >
                <Button variant="secondary" onClick={handleCancel}>
                  {t('cancel')}
                </Button>
                <Button
                  variant="primary"
                  type="submit"
                  onClick={handleSubmitCustomer}
                >
                  {t('update')}
                </Button>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Col>
  );
};
export default InformationAccount;
